import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigahireinpune() {



  const cardData = {




keyword: "Ertiga Hire in Pune",

headingDescription: "Garud Cab Service provides comfortable and reliable Ertiga Hire in Pune for family travel, airport transfers, corporate transportation, outstation journeys, sightseeing, religious tours, and long-distance trips. The Ertiga offers spacious seating, practical luggage capacity, and a comfortable cabin, making it a suitable choice for families and small groups traveling together. Customers can hire an Ertiga with a professional chauffeur for one-way journeys, round trips, airport pickup and drop, and customized travel plans. With clean and well-maintained vehicles, experienced drivers, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service provides a convenient and dependable Ertiga hire experience from Pune to destinations across Maharashtra and neighboring states.",

topPlaces: [
 
  {
    title: "Goa",
    description: "Goa is a popular holiday destination from Pune for beach vacations, family trips, honeymoon journeys, group tours, and long road trips. The Ertiga provides a comfortable and practical option for passengers traveling together with luggage. Garud Cab Service offers chauffeur-driven Ertiga hire for one-way and round-trip Goa journeys with flexible pickup arrangements."
  },
  {
    title: "Nashik",
    description: "Nashik is a major Maharashtra destination known for Trimbakeshwar, Panchavati, temples, vineyards, and scenic surroundings. Travelers can hire an Ertiga from Pune for religious visits, family travel, business trips, or sightseeing. Its spacious cabin makes it suitable for small groups looking for private and comfortable transportation."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a prominent pilgrimage destination and attracts devotees throughout the year for Sai Baba Darshan. An Ertiga is a comfortable choice for families and small groups traveling from Pune, especially when passengers need additional luggage space. Garud Cab Service provides chauffeur-driven Ertiga hire for one-way journeys, return trips, and religious tours."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is known for the Mahalaxmi Temple, Panhala Fort, Rankala Lake, traditional food, and rich cultural heritage. Families and groups traveling from Pune can hire an Ertiga for a comfortable journey and flexible sightseeing. The vehicle offers practical seating and luggage space for both direct travel and multi-stop itineraries."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination known for beaches, sea forts, coastal villages, and relaxing weekend experiences. An Ertiga is suitable for families and small groups carrying luggage for a beach holiday. Customers can hire the vehicle with a professional chauffeur for direct journeys, return travel, and customized Alibaug sightseeing."
  },
   {
    title: "Lonavala",
    description: "Lonavala is a scenic hill destination near Pune known for waterfalls, forts, lakes, valleys, and pleasant mountain surroundings. An Ertiga is a practical choice for families and small groups who want comfortable seating and sufficient luggage space for a weekend journey. Garud Cab Service offers chauffeur-driven Ertiga hire from Pune for one-way travel, return trips, and customized sightseeing."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for viewpoints, strawberry farms, Venna Lake, waterfalls, and beautiful Sahyadri landscapes. Families and groups can hire an Ertiga from Pune for a comfortable journey with convenient seating and luggage space. The vehicle is available for direct travel, round trips, and customized Mahabaleshwar sightseeing."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is an important heritage and religious destination featuring Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. An Ertiga provides comfortable transportation for families and small groups traveling from Pune. Garud Cab Service can arrange flexible hire options for direct travel, return journeys, and sightseeing around the region."
  },
  {
    title: "Ujjain",
    description: "Ujjain is a major pilgrimage destination in Madhya Pradesh and is famous for Mahakaleshwar Jyotirlinga and other spiritual attractions. Travelers from Pune planning a religious journey can hire an Ertiga for comfortable long-distance transportation. The vehicle is suitable for one-way travel, round trips, and multi-day pilgrimage itineraries."
  },
  {
    title: "Mumbai",
    description: "Mumbai is a major business and entertainment destination frequently visited from Pune for corporate meetings, airport transfers, shopping, family functions, and sightseeing. An Ertiga offers a comfortable option for families and small groups traveling together. Garud Cab Service provides chauffeur-driven Ertiga hire with flexible pickup locations and customized Mumbai travel plans."
  }
],



"services": [
{
"name": "Ertiga on Rent in Pune",
"description": "Book Ertiga on Rent in Pune for comfortable and spacious chauffeur-driven transportation with a well-maintained AC vehicle. Ertiga is suitable for family trips, corporate travel, airport transfers, local journeys, sightseeing, outstation travel, and group transportation with convenient pickup and drop arrangements."
},
{
"name": "Ertiga on Rent Pune",
"description": "Choose Ertiga on Rent Pune for reliable private travel with spacious seating, comfortable interiors, professional chauffeurs, and convenient booking options. The vehicle is suitable for families, small groups, business travelers, tourists, airport transfers, local travel, and long-distance outstation journeys."
},
{
"name": "Ertiga Car on Rent in Pune",
"description": "Hire an Ertiga Car on Rent in Pune for comfortable and practical travel with generous seating and luggage space. Enjoy chauffeur-driven AC transportation for family functions, business visits, airport transfers, sightseeing, weekend trips, local travel, and outstation journeys from Pune."
},
{
"name": "Ertiga CNG on Rent in Pune",
"description": "Book Ertiga CNG on Rent in Pune for economical and comfortable chauffeur-driven transportation with spacious seating and an efficient travel option. It is suitable for local journeys, airport transfers, family trips, corporate travel, sightseeing, and planned outstation transportation."
},
{
"name": "Ertiga Rent in Pune",
"description": "Reserve Ertiga Rent in Pune for comfortable private transportation with professional chauffeurs, clean interiors, air conditioning, and flexible pickup options. The Ertiga can be arranged for family travel, business requirements, airport transfers, sightseeing, local trips, and outstation journeys."
},
{
"name": "Ertiga Rent Per Km in Pune",
"description": "Check Ertiga Rent Per Km in Pune for convenient chauffeur-driven transportation based on your planned travel requirements. Enjoy a spacious AC vehicle with comfortable seating and luggage capacity for local travel, airport transfers, corporate trips, sightseeing, and outstation journeys."
},
{
"name": "Ertiga Rental Pune",
"description": "Choose Ertiga Rental Pune for dependable and comfortable transportation with experienced chauffeurs and well-maintained AC vehicles. The service is suitable for families, groups, corporate travelers, tourists, airport transfers, weekend trips, sightseeing, and long-distance travel."
},
{
"name": "Maruti Ertiga on Rent in Pune",
"description": "Hire Maruti Ertiga on Rent in Pune for a comfortable and spacious journey with professional chauffeur service and convenient pickup and drop arrangements. It is an ideal option for family trips, business travel, airport transfers, sightseeing, local transportation, and outstation travel."
},
{
"name": "Pune to Mahabaleshwar Ertiga Cab",
"description": "Book Pune to Mahabaleshwar Ertiga Cab for a comfortable journey with spacious seating, ample luggage capacity, air conditioning, and a professional chauffeur. The service is suitable for families, friends, couples, and groups planning a relaxed trip from Pune to Mahabaleshwar."
},
{
"name": "Pune to Mahabaleshwar Cab for 2 Days",
"description": "Reserve Pune to Mahabaleshwar Cab for 2 Days for convenient round-trip transportation and sightseeing during your stay. Travel in a comfortable AC Ertiga with a professional chauffeur and enjoy flexible pickup, local sightseeing, luggage space, and convenient return arrangements."
},
{
"name": "Pune to Mahabaleshwar Ertiga Booking",
"description": "Make Pune to Mahabaleshwar Ertiga Booking for a spacious and comfortable family or group journey with a professional chauffeur. The Ertiga provides convenient seating, luggage capacity, AC travel, and flexible pickup options for sightseeing, weekend trips, and planned tours."
},
{
"name": "Pune to Mahabaleshwar Tour Package",
"description": "Book a Pune to Mahabaleshwar Tour Package with a comfortable Ertiga cab for convenient transportation, sightseeing, and return travel. Enjoy chauffeur-driven AC travel with flexible scheduling for families, groups, couples, weekend travelers, and tourists exploring Mahabaleshwar and nearby attractions."
},
{
"name": "Pune to Mumbai Ertiga Cab",
"description": "Hire Pune to Mumbai Ertiga Cab for comfortable intercity transportation with spacious seating, luggage capacity, air conditioning, and an experienced chauffeur. The service is suitable for family travel, corporate visits, airport transfers, business trips, and one-way or round-trip journeys."
},
{
"name": "Pune to Mumbai Airport Ertiga Cab",
"description": "Book Pune to Mumbai Airport Ertiga Cab for a convenient airport transfer with spacious seating and luggage-friendly transportation. Enjoy professional chauffeur service, comfortable AC travel, flexible pickup arrangements, and direct drop facilities for individuals, families, and groups traveling to Mumbai Airport."
},
{
"name": "Pune to Nashik Ertiga Cab Booking",
"description": "Reserve Pune to Nashik Ertiga Cab Booking for a comfortable and spacious intercity journey with an experienced chauffeur. The Ertiga is suitable for families, groups, business travelers, tourists, religious visits, sightseeing, and one-way or round-trip travel between Pune and Nashik."
},
{
"name": "Pune to Shirdi Ertiga Cab Booking",
"description": "Book Pune to Shirdi Ertiga Cab Booking for a comfortable pilgrimage journey with spacious seating, luggage capacity, AC travel, and professional chauffeur service. The vehicle is suitable for families and groups visiting Shirdi for Sai Baba darshan, sightseeing, and planned return trips."
},
{
"name": "Pune to Goa Ertiga Cab",
"description": "Choose Pune to Goa Ertiga Cab for a comfortable long-distance road journey with spacious seating, air conditioning, luggage space, and professional chauffeur service. The Ertiga is suitable for families, friends, groups, weekend trips, holidays, sightseeing, and one-way or round-trip Goa travel."
},
{
"name": "Pune to Lonavala Ertiga Cab",
"description": "Book Pune to Lonavala Ertiga Cab for a comfortable family or group journey with spacious seating, AC interiors, luggage capacity, and a professional chauffeur. It is suitable for weekend trips, sightseeing, family outings, corporate travel, and one-day or round-trip journeys."
},
{
"name": "Kolhapur to Pune Ertiga Cab Booking",
"description": "Reserve Kolhapur to Pune Ertiga Cab Booking for comfortable and reliable intercity transportation with a professional chauffeur. Enjoy spacious seating, clean AC interiors, luggage capacity, and convenient pickup and drop arrangements for families, business travelers, tourists, and groups."
},
{
"name": "Pune to Kolhapur Ertiga Cab",
"description": "Hire Pune to Kolhapur Ertiga Cab for a comfortable private journey with spacious seating, air conditioning, ample luggage space, and experienced chauffeur service. The vehicle is suitable for family travel, business visits, sightseeing, personal trips, and one-way or round-trip transportation."
},
{
"name": "Ertiga Hire in Pimpri Chinchwad",
"description": "Book Ertiga Hire in Pimpri Chinchwad for comfortable chauffeur-driven transportation with spacious seating and convenient pickup options. The vehicle is suitable for local travel, airport transfers, family outings, corporate journeys, sightseeing, and outstation trips from Pimpri Chinchwad."
},
{
"name": "Ertiga Hire in Aundh Baner",
"description": "Choose Ertiga Hire in Aundh Baner for convenient and spacious private transportation with professional chauffeurs and well-maintained AC vehicles. It is suitable for families, corporate travelers, airport transfers, local trips, weekend outings, sightseeing, and outstation journeys."
},
{
"name": "Ertiga Hire in Hinjewadi Pune",
"description": "Reserve Ertiga Hire in Hinjewadi Pune for comfortable transportation with spacious seating, luggage capacity, AC interiors, and professional chauffeur service. The service is suitable for IT professionals, corporate travel, airport transfers, family trips, local journeys, and outstation transportation."
},
{
"name": "Ertiga Rent Per Km in Pune",
"description": "Get Ertiga Rent Per Km in Pune for convenient travel planning with a spacious chauffeur-driven vehicle. Enjoy comfortable AC transportation for local and outstation journeys, family trips, business travel, airport transfers, sightseeing, and long-distance routes with suitable travel arrangements."
},
{
"name": "Ertiga Cabs in Viman Nagar Pune",
"description": "Book Ertiga Cabs in Viman Nagar Pune for spacious and comfortable chauffeur-driven travel with convenient pickup and drop facilities. The service is suitable for airport transfers, corporate travel, family journeys, local transportation, sightseeing, and outstation trips from Viman Nagar."
},
{
"name": "Ertiga on Rent in Kharadi",
"description": "Hire Ertiga on Rent in Kharadi for comfortable private transportation with spacious seating, AC interiors, luggage capacity, and professional chauffeur service. It is suitable for corporate travelers, families, airport transfers, local journeys, weekend trips, sightseeing, and outstation travel."
},
{
"name": "Ertiga Cab in Hadapsar Magarpatta",
"description": "Choose Ertiga Cab in Hadapsar Magarpatta for convenient and comfortable chauffeur-driven transportation with spacious seating and flexible pickup arrangements. The vehicle is suitable for corporate travel, family trips, airport transfers, local journeys, sightseeing, and outstation transportation."
}
],
"tableData": [
["Ertiga on Rent in Pune", "Ertiga on Rent Pune"],
["Ertiga Car on Rent in Pune", "Ertiga CNG on Rent in Pune"],
["Ertiga Rent in Pune", "Ertiga Rent Per Km in Pune"],
["Ertiga Rental Pune", "Maruti Ertiga on Rent in Pune"],
["Pune to Mahabaleshwar Ertiga Cab", "Pune to Mahabaleshwar Cab for 2 Days"],
["Pune to Mahabaleshwar Ertiga Booking", "Pune to Mahabaleshwar Tour Package"],
["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Airport Ertiga Cab"],
["Pune to Nashik Ertiga Cab Booking", "Pune to Shirdi Ertiga Cab Booking"],
["Pune to Goa Ertiga Cab", "Pune to Lonavala Ertiga Cab"],
["Kolhapur to Pune Ertiga Cab Booking", "Pune to Kolhapur Ertiga Cab"],
["Ertiga Hire in Pimpri Chinchwad", "Ertiga Hire in Aundh Baner"],
["Ertiga Hire in Hinjewadi Pune", "Ertiga Rent Per Km in Pune"],
["Ertiga Cabs in Viman Nagar Pune", "Ertiga on Rent in Kharadi"],
["Ertiga Cab in Hadapsar Magarpatta", ""]
],



whychoose: [
  {
    WhyChooseheading: "Ertiga Hire in Pune for Everyday & Outstation Travel",
    WhyChoosedescription: "Garud Cab Service provides Ertiga hire in Pune for families, small groups, airport transfers, local travel, weekend outings, business requirements, and outstation journeys where a spacious and practical vehicle is preferred."
  },
  {
    WhyChooseheading: "Comfortable Choice for Small Groups",
    WhyChoosedescription: "With useful cabin space and seating capacity, the Ertiga is a convenient option for families and groups who want to travel together without compromising on comfort or luggage space."
  },
  {
    WhyChooseheading: "Hire for Local Pune Travel",
    WhyChoosedescription: "Use an Ertiga for city sightseeing, family functions, shopping trips, hotel transfers, office requirements, social events, and other local transportation needs across Pune."
  },
  {
    WhyChooseheading: "Convenient for Outstation Journeys",
    WhyChoosedescription: "Plan trips from Pune to nearby cities, hill stations, religious destinations, beaches, and other outstation locations with an Ertiga arranged according to your travel schedule."
  },
  {
    WhyChooseheading: "Airport Transfers with Luggage Space",
    WhyChoosedescription: "Ertiga hire is suitable for Pune Airport pickup and drop when passengers are travelling with family members and luggage and require a practical vehicle for the transfer."
  },
  {
    WhyChooseheading: "Useful for Events & Family Occasions",
    WhyChoosedescription: "Hire an Ertiga for weddings, family gatherings, celebrations, guest transportation, corporate events, and other occasions where convenient group mobility is required."
  },
  {
    WhyChooseheading: "Driver-Driven Travel Option",
    WhyChoosedescription: "Customers can arrange a chauffeur-driven Ertiga with a professional driver, allowing passengers to focus on their itinerary while the driver manages the road journey."
  },
  {
    WhyChooseheading: "Easy Ertiga Booking with Garud",
    WhyChoosedescription: "Share your pickup point, destination, travel date, passenger count, rental duration, and local or outstation requirement to arrange an Ertiga hire in Pune with Garud Cab Service."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Ertiga Hire in Pune?",
    answer: "Yes, Garud Cab Service provides Ertiga hire services in Pune for local travel, airport transfers, family trips, events, corporate requirements, and outstation journeys."
  },
  {
    question: "Can I hire an Ertiga for outstation travel?",
    answer: "Yes, Ertiga hire can be arranged for suitable outstation destinations from Pune according to your travel dates and transportation requirements."
  },
  {
    question: "Is Ertiga available with a driver?",
    answer: "Yes, chauffeur-driven Ertiga arrangements can be provided for customers who prefer convenient and professionally managed transportation."
  },
  {
    question: "Can I hire an Ertiga for Pune Airport?",
    answer: "Yes, Ertiga can be arranged for Pune Airport pickup and drop services, including travel with passengers and luggage."
  },
  {
    question: "Is Ertiga suitable for family travel?",
    answer: "Yes, the Ertiga is a practical choice for families and small groups because it provides comfortable seating and useful luggage space."
  },
  {
    question: "Can I hire an Ertiga for a wedding or event?",
    answer: "Yes, Ertiga hire is suitable for weddings, family functions, guest transportation, social events, corporate gatherings, and celebrations."
  },
  {
    question: "Can I hire an Ertiga for one day?",
    answer: "Yes, one-day Ertiga hire can be arranged for local sightseeing, airport transfers, family outings, events, and suitable short-distance travel plans."
  },
  {
    question: "Can I hire an Ertiga for multiple days?",
    answer: "Yes, multi-day Ertiga arrangements can be planned for holidays, outstation tours, religious trips, family vacations, and extended travel requirements."
  },
  {
    question: "Can corporate customers hire an Ertiga in Pune?",
    answer: "Yes, Ertiga hire can be used for employee transportation, client visits, business meetings, corporate events, and other professional travel requirements."
  },
  {
    question: "How can I hire an Ertiga in Pune?",
    answer: "Share your pickup location, destination, travel date, passenger count, rental duration, and driver requirement with Garud Cab Service to arrange your Ertiga."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Chavan",
    feedback: "We hired an Ertiga in Pune for a family outing and found the vehicle comfortable for our group. There was also sufficient space for our bags.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Nair",
    feedback: "I booked an Ertiga with a driver for an outstation family trip. The vehicle was spacious and the overall arrangement was convenient for our travel plan.",
    rating: 5
  }
];







  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga Hire in Pune",
  "image": "https://garudcabs.com/assets/images/ertiga-hire-in-pune.webp",
  "description": "Hire an Ertiga in Pune with Garud Cab for comfortable, spacious, and dependable local and outstation travel. Get Maruti Ertiga rental and cab services for airport transfers, family trips, corporate travel, sightseeing, Pune to Mumbai journeys, and long-distance routes with flexible rental and per-kilometer options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/ertiga-hire-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Ertiga Hire in Pune | Ertiga Rental & Cab Service | +91 9970007784</title>

  <meta
    name="description"
    content="Hire an Ertiga in Pune with Garud Cab for comfortable local, airport, and outstation travel. Get Maruti Ertiga rental, taxi, and cab services with flexible rental and per-kilometer options for family and corporate journeys."
  />

  <meta
    name="keywords"
    content="Ertiga on rent in Pune, Ertiga on rent Pune, Ertiga car on rent in Pune, Ertiga CNG on rent in Pune, Ertiga rent in Pune, Ertiga rent per km in Pune, Ertiga rental Pune, Maruti Ertiga on rent in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigahireinpune;